// Staff permission levels from backend StaffPermissionLevelEnum
export const STAFF_ROLES = {
  OWNER: 'owner',
  ADMIN: 'admin',
  STAFF: 'staff',
} as const;

export type StaffRole = typeof STAFF_ROLES[keyof typeof STAFF_ROLES];

// Helper function to get display name for role
export const getRoleDisplayName = (role: string): string => {
  switch (role) {
    case STAFF_ROLES.OWNER:
      return 'Owner';
    case STAFF_ROLES.ADMIN:
      return 'Admin';
    case STAFF_ROLES.STAFF:
      return 'Staff';
    default:
      return 'Staff';
  }
};

// Helper function to get role color
export const getRoleColor = (role: string): 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success' => {
  switch (role) {
    case STAFF_ROLES.OWNER:
      return 'secondary';
    case STAFF_ROLES.ADMIN:
      return 'error';
    case STAFF_ROLES.STAFF:
      return 'primary';
    default:
      return 'primary';
  }
};

// Helper function to get staff role for a specific store
export const getStaffRoleForStore = (staffMember: any, storeId: string): StaffRole => {
  if (!staffMember.staffStores || !Array.isArray(staffMember.staffStores)) {
    return STAFF_ROLES.STAFF;
  }
  
  const staffStore = staffMember.staffStores.find((ss: any) => ss.store?.id === storeId);
  const role = staffStore?.role || STAFF_ROLES.STAFF;
  
  // Normalize the role value to ensure it matches the expected format
  const normalizedRole = role?.toLowerCase();
  switch (normalizedRole) {
    case 'owner':
      return STAFF_ROLES.OWNER;
    case 'admin':
      return STAFF_ROLES.ADMIN;
    case 'staff':
      return STAFF_ROLES.STAFF;
    default:
      return STAFF_ROLES.STAFF;
  }
};

export interface StaffFormData {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  password: string;
  services: string[];
  role: StaffRole;
  title: string;
  isActive: boolean;
}
